/**
 * Shared fields for recipe detail (SWR + API.getRecipe). Keep in sync.
 * `layout_translations.videos.*` expands M2M to junction + linked `videos` row ids.
 */
export const RECIPE_DETAIL_FIELDS =
  '*,food_service_configurations.*,layout_translations.*,' +
  'layout_translations.videos.id,layout_translations.videos.videos_id,layout_translations.videos.videos_id.id,' +
  'coupons.coupon_id.*,coupons.coupon_id.translations.*,beef_products.*,beef_products.beef_product_id.*,beef_products.beef_product_id.translations.*,' +
  'imagegallery.*,cooking_method.*,category.recipe_categories_id.translations.*,category.recipe_categories_id.*,recipe_directions.*.*,youtube.*,' +
  'video_overrides.status,video_overrides.retailer,video_overrides.translations.*';
